/**
 * 核心http
 * @description  request工具类 axios拦截器
 * @module core/request
 * @author yujingxuan
 */

// 请求拦截
export function requestInterceptor(config) {
  config.data = {
    ...config.data,
    platform: 'm'
  }
  return config;
}

// 响应拦截
export async function responseSuccessHandler(response) {

  const res = response.data
  if(!res.success) {
    // Toast(res?.message || '未知错误')
    console.log(res);
  }
  return res
}
// 
export async function responseSuccessVipHandler(response) {
  const res = response.data
  return res
}

//  响应错误拦截
export function responseErrorHandler(error) {
  return Promise.reject(error)
}
//  请求错误拦截
export function requestRejectInterceptor(error) {
  return Promise.reject(error)
}
